import React from 'react';
import Lottie from 'react-lottie';
import './Loading_Lottie.css';
import * as animationData from './Loading_Lottie.json';

function Loading_Lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <section className='main'>
      <div className='Loading_Lottie_icon'>
        <Lottie className="me-auto"
          options={defaultOptions}
        // height={60}
        // width={60}          
        />
      </div>
    </section>
  );
}
export default Loading_Lottie;